// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonA_container__3jxMJ","title":"ButtonA_title__1vxbX","rightIcon":"ButtonA_rightIcon__2FzDR","leftIcon":"ButtonA_leftIcon__25WUX"};